import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/index'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '',
      redirect: '/home'
    }, {
      name: 'home',
      path: '/home',
      component: Home
    }
  ]
})
